<div class="programCard" [ngClass]="{active: show?.isCurrentlyPlaying}">
    <div class="dateLine">
        <div class="time">
            {{ show?.start?.toDate() | date:"h:mm":tz}}
        </div>
        <div class="timeOfDay">
            {{ show?.start?.toDate() | date:"a":tz }} / {{ tzStr }}
        </div>

        <div class="date1">
            {{ show?.start?.toDate() | date:"EEEE":tz}}, <span class="upper">{{ show?.start?.toDate() | date:"MMM dd":tz}}</span>
        </div>
    </div>

    <div class="content">
        <div class="left">
            <div class="title">{{ show?.title }}</div>
            <!-- <div class="cast"> Nicholas Cage, Amber Heard -->
            <!-- </div> -->
            <div class="description"> {{show?.description}} </div>
            <div class="genre"> <b>Genre:</b> {{show?.genre }} </div>
            <div class="combined">
                <div class="rating"> <b>Rating:</b> {{show?.ratingAge }} </div>
                <!-- <div class="released"> <b> Released:</b>[- Release year -] </div> -->
            </div>
        </div>
        <div class="right">
            <div class="image">
                <img [src]="show?.thumbnail" alt="">
            </div>
            <div *ngIf="!show.disabled && !show.isCurrentlyPlaying" class="downloadButton" (click)="addToCalendar(show)" (mouseover)="onCalendarOver($event)" (mouseout)="onCalendarOut($event)">
                <div class="pls">+</div>
                <div class="downlText">CALENDAR</div>
            </div>
            <div *ngIf="!show.disabled && show.isCurrentlyPlaying" class="downloadButton red" >
                <!-- <div class="pls">+</div> -->
                <div class="downlText">NOW PLAYING</div>
            </div>
        </div>
    </div>


    <!-- <div class="left">
        <div class="date">
            <div class="date1">
                {{ show?.start?.toDate() | date:"EEE, MMM dd":tz}}
            </div>
            <div class="time">
                {{ show?.start?.toDate() | date:"h:mm":tz}}
            </div>
            <div class="timeOfDay">
                {{ show?.start?.toDate() | date:"a":tz }} / {{ tzStr }}
            </div>

            <div class="onNow" *ngIf="isActive">ON NOW</div>
            <div class="isNext" *ngIf="isNext">UP NEXT</div>
        </div>
        <div class="image">
            <img [src]="show?.thumbnail" alt="">
        </div>
    </div>  -->

    <!-- <div class="right">
        <div class="title">{{ show?.title }}</div>
        <div class="cast"> [- Cast Names -] </div>
        <div class="genre"> <b>Genre:</b> {{show?.genre }} </div>
        <div class="combined">
            <div class="rating"> <b>Rating:</b> {{show?.parentalRating }} </div>
            <div class="released"> <b> Released:</b>[- Release year -] </div>
        </div>
    </div> -->

    <!-- <div class="side">
        <div class="plusBtn">
            +
        </div>
        <div class="moreInfoLink">
            <a [routerLink]="'/show/' + show?.programId">
                More&nbsp;Info
            </a>
        </div>
    </div> -->
</div>
